export default __webpack_public_path__ + "static/media/jude.0df44072.jpg";